import { types } from "../../types/types";
import { basicMsg, htmlMsg } from "../swal_msg";
import { protectedFormReq, protectedReq } from "../../helpers/requestHelper";

export const loadDoctors = () => {
    // cargar lista de médicos en admin
    return async(dispatch) => {
        try {
            const resp = await protectedReq('doctor/list');
            const body = await resp.json();
            if (body.status)
                dispatch(doctorsLoaded(body.resp));
        } catch (err) {}
    }
};

const doctorsLoaded = (payload) => ({
    type: types.doctorsLoaded,
    payload
});

// registrar médico
export const saveDoctor = async (model, image = null) => {
    try {
        const form = new FormData();
        Object.entries(model).forEach(([key, value]) => form.append(key, value ?? ''));
        if (image) form.append('image', image);
        const resp = await protectedFormReq('doctor/save', form, 'POST');
        const body = await resp.json();
        if (!body.status) {
            if (body.msg === 'miss')
                basicMsg('Faltan datos del especialista');
            else if (body.msg === 'server-err')
                basicMsg('Ocurrió un incidente');
            else if (body.msg === 'doctor-exists')
                basicMsg('Ya existe un médico con la misma cédula profesional');
            else if (body.msg === 'forbidden')
                basicMsg('No cuenta con permisos para registrar médicos');
            else if (body.msg === 'image-not-saved')
                basicMsg('No fue posible guardar la fotografía. El médico no fue registrado.');
        }
        return body;
    } catch (err) {
        htmlMsg('error', 'Médico',
        `<p>No se pudo registrar el médico</p><h6>Error: ${err}</h6>`);
        return { status: false };
    };
};

// actualizar médico
export const updDoctor = (model, onSuccess = () => {}) => {
    return async(dispatch) => {
        try {
            const resp = await protectedReq('doctor/update', model, 'PUT');
            const body = await resp.json();
            if (!body.status) {
                const { msg } = body;
                if (msg === 'miss')
                    alert('Faltan datos del especialista');
                else
                    alert(msg);
            } else {
                const { doctor } = body.resp;
                dispatch(doctorUpdated(doctor));
                onSuccess();
                basicMsg('Médico actualizado');
            }
        } catch (err) {
            htmlMsg('error', 'Médico',
            `<p>No se pudo actualizar el médico</p><h6>Error: ${err}</h6>`);
        };
    };
};

const doctorUpdated = (payload) => ({
    type: types.doctorUpdated,
    payload
});

// eliminar médico
export const deleteDoctor = (row) => {
    return async(dispatch) => {
        try {
            const model = { _id: row._id };
            const resp = await protectedReq('doctor/delete', model, 'DELETE');
            const body = await resp.json();
            if (!body.status) {
                const { msg } = body;
                if (msg === 'miss')
                    alert('Faltan datos del especialista');
                else if (msg === 'doctor-has-coupons')
                    basicMsg(`No se puede eliminar: tiene ${body.resp.coupon_count} cupón(es) enlazado(s)`);
                else
                    alert(msg);
            } else
                dispatch(doctorDeleted(model));
        } catch (err) {
            htmlMsg('error', 'Médico',
            `<p>No se pudo eliminar el médico</p><h6>Error: ${err}</h6>`);
        };
    };
};

const doctorDeleted = (payload) => ({
    type: types.doctorDeleted,
    payload
});
